import React from 'react'

//@ts-ignore
import loadable from '@loadable/component'
import {AccountBonusCardTopup} from './pages/bonus-card-topup'
import {MealDeals} from './pages/meal-deals'
import MRTDashboard from './pages/mrt-dashboard'

const fallback = <div />

// Pages
const Home = loadable(() => import('./pages/home'), {fallback})
const Category = loadable(() => import('./pages/category'), {fallback})
const Search = loadable(() => import('./pages/search'), {fallback})
const Product = loadable(() => import('./pages/product'), {fallback})
const MyFavouritesPage = loadable(() => import('./pages/my-favourites'), {fallback})
const BeforeYouGo = loadable(() => import('./pages/before-you-go'), {fallback})
const Account = loadable(() => import('./pages/account'), {fallback})
const Cart = loadable(() => import('./pages/cart'), {fallback})
const CheckoutWrapper = loadable(() => import('./pages/checkout-wrapper'), {fallback})
const orderConfirmation = loadable(() => import('./pages/order-confirmation'), {fallback})
const Login = loadable(() => import('./pages/login'), {fallback})
const Registration = loadable(() => import('./pages/registration'), {fallback})
const RegistrationComplete = loadable(() => import('./pages/registration/complete'), {fallback})
const Visualization = loadable(() => import('./pages/admin/Visualization'), {fallback})
const Content = loadable(() => import('./pages/content'), {fallback})
const Styleguide = loadable(() => import('./pages/styleguide'), {fallback})
const CmsDevTest = loadable(() => import('./pages/cms-dev-test'), {fallback})
const Error501 = loadable(() => import('./pages/error501'), {fallback})
const BookDelivery = loadable(() => import('./pages/book-delivery'), {fallback})
const SelectDelivery = loadable(() => import('./pages/select-delivery'), {fallback})
const PreBookDelivery = loadable(() => import('./pages/pre-book-delivery'), {fallback})
const PreBookDeliveryPayment = loadable(() => import('./pages/pre-book-delivery-payment'), {fallback})
const CmsStyleGuide = loadable(() => import('./pages/cms-style-guide'), {fallback})
const StoreFinder = loadable(() => import('./pages/store-finder'), {fallback})
const Sitemap = loadable(() => import('./pages/sitemap'), {fallback})
const PageNotFound = loadable(() => import('./pages/page-not-found'), {fallback})
const ResetAndContinueShopping = loadable(() => import('./pages/reset-and-continue-shopping'), {fallback})

const routes = [
  {path: '/', component: Home, exact: true},
  {path: '/cms-dev-test', component: CmsDevTest, exact: true},
  {path: '/style-guide', component: CmsStyleGuide},
  {path: '/account/register', component: Registration, exact: true},
  {path: '/account/register/complete', component: RegistrationComplete},
  {path: '/account/bonus-card/topup', component: AccountBonusCardTopup, exact: true},
  {path: '/account/bonus-card/topup/confirmation', component: orderConfirmation},
  {path: '/account', component: Account},
  {path: '/p/:productName/:productId.html', component: Product},
  {path: '/p/:productId', component: Product},
  {path: '/search', component: Search},
  {path: '/category/:categoryId', component: Category},
  {path: '/basket', component: Cart, exact: true},
  {path: '/checkout/summary', component: CheckoutWrapper},
  {path: '/orderconfirmation', component: orderConfirmation},
  {path: '/login', component: Login},
  {path: '/book-delivery', component: BookDelivery},
  {path: '/select-delivery', component: SelectDelivery},
  {path: '/pre-book-delivery', component: PreBookDelivery, exact: true},
  {path: '/pre-book-delivery/payment', component: PreBookDeliveryPayment},
  {path: '/pre-book-delivery/confirmation', component: orderConfirmation},
  {path: '/my-favourites', component: MyFavouritesPage},
  {path: '/Iceland-BeforeYouGoPages', component: BeforeYouGo},
  {path: '/terms.html', component: Content},
  {path: '/store-finder', component: StoreFinder},
  {path: '/store-finder/all-stores', component: StoreFinder},
  {path: '/basket/addalltobasket', component: Home},
  {path: '/meal-deals', component: MealDeals},
  {path: '/pages/sitemap', component: Sitemap},
  {path: '/page-not-found', component: PageNotFound},
  {path: '/reset', component: ResetAndContinueShopping},

  // Admin routes
  {path: '/admin/visualization', component: Visualization},
  {path: '/admin/preview', component: Home},
  {path: '/styleguide', component: Styleguide},
  {path: '/error501', component: Error501},
  {path: '/mrt-dashboard', component: MRTDashboard},
  {path: '/tsob', component: Home, exact: true},

  // Fallback for all other pages
  {path: '*', component: Content},
]

export default routes
